module.exports = __webpack_public_path__ + "media/img/help_center/Student_Academic_Profile_01-ab79d6b97fa32c8e7eb2029e842c7e02.jpg";